import axios from 'axios';
import { supabase } from './supabaseClient';

// CRA-friendly env + local dev proxy
const API_BASE =
  process.env.REACT_APP_API_BASE ||
  (typeof window !== 'undefined' && window.location.hostname === 'localhost'
    ? '/api'
    : 'https://api.arch-intelligence.ai/api');

const api = axios.create({
  baseURL: API_BASE.replace(/\/+$/, ''),
  withCredentials: false,
});

// Attach Authorization on every request
api.interceptors.request.use(async (config) => {
  config.headers = config.headers || {};
  const { data: { session } } = await supabase.auth.getSession();
  const token = session?.access_token;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  else delete config.headers.Authorization;
  return config;
});

// Retry once on 401 in case we raced a refresh
api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const cfg = err?.config || {};
    if (err?.response?.status === 401 && !cfg.__retry) {
      cfg.__retry = true;
      const { data: { session } } = await supabase.auth.getSession();
      if (session?.access_token) {
        cfg.headers = cfg.headers || {};
        cfg.headers.Authorization = `Bearer ${session.access_token}`;
        return api(cfg);
      }
    }
    return Promise.reject(err);
  }
);

export default api;
export { api };
